export const  FileRoutes = {
   
    uploadImage: "/media/uploadImage",
    uploadDocument: "system/uploadDoc",
    
    
  };
    